export default __webpack_public_path__ + "static/media/07_July.51751969.png";